package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.printer_location

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.printer_location.PrinterLocation
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.grid_function.GridFunction
import org.hs_soft.runmynesto.pages.components.grid_function.GridItemsList
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState

@Composable
fun PrinterLocations(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {

    LaunchedEffect(Unit){
        event(OptionsEvent.GetPrintersLocation)
    }


    Column(
        modifier = Modifier
            .fillMaxSize()
            .borderSetting()
            .borderRadius(Dimen.semiLargeRadius)
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
    )
    {
        MediumContentTitle(
            title = Strings.current().printerLocations,
            marginBottom = Dimen.mediumPadding,
        )

        GridFunction(
            modifier = Modifier,
            title = Strings.current().name,
            infoTitle = Strings.current().numberDot,
            footerTitle = Strings.current().items,
            showAddItemIcon = true,
            fillMaxWidth = windowSizeMode== WindowSizeModeEnum.PHONE,
            infoList = state.printersLocation?: listOf(),
            showRefreshIcon = false,
            onAddItemClick = {
                event(OptionsEvent.ShowAddPrinterLocationRecordDialog)
            },
            content = {
                GridItemsList(
                    id = "",
                    items = state.printersLocation ?: listOf(),
                    onItemClick = {
                        if (it is PrinterLocation) {
                            event(
                                OptionsEvent.ShowUpdatePrinterLocationRecordDialog(
                                    status = true,
                                    dbIndex = it.dbIndex,
                                    name = it.value
                                )
                            )
                        }

                    },
                )
            }
        )
    }






}